if (!getHealthy) {
    var getHealthy = {};
}

getHealthy.bmicalc = {
    init: function () {
        getHealthy.bmicalc.setMarkup();
        jcf.customForms.replaceAll();
        $('.jcf-unselectable').css({width: '270px'});
        getHealthy.bmicalc.setEvents();
    },
    setMarkup: function () {
        //setup form and markup
        var markup = [];
        var i = 0;
        markup.push('<div id="bmi_calculator_widget" class="calculator_widget" style="display: none;"><form action="#" class="calculator" id="calculator_bmi">');
        markup.push('    <fieldset>');
        markup.push('        <p><label class="title_label" for="r_weight">Weight *</label><select tabindex="0" aria-controls="result" name="weight" id="r_weight">');
        markup.push('                <option disabled="disabled" selected="selected">Please select...</option>');
        for (i=10; i<251; i=i+1) {
            markup.push('                <option value="'+i+'">'+i+' kg</option>');
        }
        markup.push('            </select></p>');
        markup.push('        <p><label class="title_label" for="r_height">Height *</label><select tabindex="0" aria-controls="result" name="height" id="r_height">');
        markup.push('                <option disabled="disabled" selected="selected">Please select...</option>');
        for (i=70; i<220; i=i+1) {
            markup.push('                <option value="'+i+'">'+i+' cm</option>');
        }
        markup.push('            </select></p>');
        markup.push('    </fieldset>');
        markup.push('</form>');
        markup.push('<div class="calc_results"><h2>Your BMI:</h2><h3 class="bmi" tabindex="0" id="result" aria-label="Result">-</h3></div><div class="breaker"></div></div>');
        $('#content h2, #content h3').eq(0).after(markup.join('\n'));
        $('#bmi_calculator_widget').slideDown(500);
    },
    setEvents: function () {
        $('select').on('change', function (event) {
            getHealthy.bmicalc.updateTotals(event);
            return false;
        });
        $('#calculator').on('submit', function (event) {
            getHealthy.bmicalc.updateTotals(event);
            return false;
        });
        $('#calculator input[type="submit"]').on('click', function (event) {
            getHealthy.bmicalc.updateTotals(event);
            return false;
        });
    },
    updateTotals: function (event) {
        var ec = new EnergyConversion;
        var bmi = 0;
        event.preventDefault;
        var sex = $('#r_sex').val() || '';
        var weight = parseInt($('#r_weight').val(), 10) || 0;
        var height = parseInt($('#r_height').val(), 10) || 0;



        if (weight > 0 && height > 0 ) {

            bmi = weight / (Math.pow(height/100, 2));
            $('#bmi_calculator_widget .calc_results h3').html( Math.round(bmi*10)/10 ) ;
        }

        return false;

    }
};
$(document).ready(function () {
    getHealthy.bmicalc.init();
});



//emmet: form>fieldset>(p>label[for="r_sex"]{Sex}+select[id="r_sex"]>option{Male}+option{Female})+(p>label[for="r_weight"]{Weight}+select[id="r_weight"]>(option[value="$"]{$ kg})*250)+(p>label[for="r_age"]{Age}+select[id="r_age"]>(option[value="$"]{$ years})*100)+(p>label[for="r_activework"]{How active are you at work?}+select[id="r_activework"]>option[value="0"]{Light}+option[val="1"]{Moderate}+option[value="2"]{Heavy})+(p>label[for="r_activeplay"]{How active are you at Play?}+select[id="r_activeplay"]>option[value="0"]{Light}+option[value="1"]{Moderate}+option[value="2"]{Heavy})+(p>label[for="r_goal"]{Weight goal?}+select[id="r_goal"]>option[value="0"]{No change}+option[value="1"]{Lose 0.5kg per week})+(p>input[type="Submit" value="Find my figure"])
//
//

